module.exports = __webpack_public_path__ + "img/md-podium.87a7b8d2.svg";